// --- Components ---
import Icon from "../common/components/Icon/Icon";
import Breadcrumbs from "../common/components/Breadcrumbs/Breadcrumbs";
import LanguageSwitcher from "../common/features/language/components/LanguageSwitcher";

// --- Hooks ---
import {
  useAppDispatch,
  useAppSelector,
  useMediaQuery,
  useMutationWithFeedback,
  useUnsavedChangesWarning,
} from "../common/hooks/hooks";
import { useLanguage } from "../common/features/language/hooks/useLanguage";

// --- Helpers & Utils ---
import { formatPrice } from "../common/helpers/formatPrice";
import { decodeHtmlEntities } from "../common/helpers/decodeHtmlEntities";
import { areAddressesEqual } from "../common/helpers/addressHelpers";
import { getCookie, setCookie, removeCookie } from "../common/helpers/cookie";
import {
  loadFromLocalStorage,
  saveToLocalStorage,
} from "../common/helpers/localStorage";

// --- Global UI Actions (Redux) ---
import {
  openGlobalModal,
  closeGlobalModal,
} from "../common/features/globalModal/globalModalSlice";
import {
  openGlobalPopup,
  closeGlobalPopup,
} from "../common/features/globalPopup/globalPopupSlice";
import {
  openMultiPanelOffcanvas,
  closeMultiPanelOffcanvas,
  setMultiPanelActivePanel,
} from "../common/features/multiPanelOffcanvas/multiPanelOffcanvasSlice";

// --- Vanilla JS Features ---
import ConsentManager from "../common/features/cookieConsent/ConsentManager";
import { refreshScrollTriggers } from "../common/animation/scrollAnimations";

export const common = {
  // 1. UI Components
  components: {
    Icon,
    Breadcrumbs,
    LanguageSwitcher,
  },

  // 2. React / Redux Hooks
  hooks: {
    useAppDispatch,
    useAppSelector,
    useMediaQuery,
    useMutationWithFeedback,
    useUnsavedChangesWarning,
    useLanguage,
  },

  // 3. Redux Actions (To control core layout elements from the theme)
  actions: {
    modal: {
      openGlobalModal,
      closeGlobalModal,
    },
    popup: {
      openGlobalPopup,
      closeGlobalPopup,
    },
    offcanvas: {
      openMultiPanelOffcanvas,
      closeMultiPanelOffcanvas,
      setMultiPanelActivePanel,
    },
  },

  // 4. Pure Helper Functions
  helpers: {
    formatPrice,
    decodeHtmlEntities,
    areAddressesEqual,
    cookie: {
      get: getCookie,
      set: setCookie,
      remove: removeCookie,
    },
    storage: {
      load: loadFromLocalStorage,
      save: saveToLocalStorage,
    },
  },

  // 5. Vanilla JS Utilities
  utils: {
    ConsentManager,
    refreshScrollTriggers, // Useful if the theme heavily manipulates the DOM and breaks GSAP layouts
  },
};
